<template>
    <div class="container user-edit content-box">
      <div class="mb-5 ">
        <h1
          class="text-center"
          :class="settings.attributes.title.class"
          :style="settings.attributes.title.style"
          v-safe-html="settings.attributes.title.text"
        />
        <h4
          class="text-center"
          :class="settings.attributes.subtitle.class"
          :style="settings.attributes.subtitle.style"
          v-safe-html="settings.attributes.subtitle.text"
        />
      </div>
      <user-complete-profile-fields
        @update-success="redirectToBuildingLists()"
      />
    </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import router from '../../router/index';
import UserCompleteProfileFields from '../../components/UserCompleteProfileFields.vue';

export default {
  name: 'UserCompleteProfile',

  components: {
    UserCompleteProfileFields,
  },

  computed: {
    partner() {
      return this.$store.state.partners.currentPartner;
    },

    settings() {
      return this.partner.settings.sections.user_edit_page;
    },
  },

  methods: {
    redirectToBuildingLists() {
      this.$store.dispatch('buildings/setNew').then(() => {
        router.push({ name: 'buildings-list' });
      });
    },
  },
};
</script>
